module.exports = __webpack_public_path__ + "static/media/image21.19519a8b.JPG";